import React from "/vendor/react";
import { SvgIcon } from "/vendor/@material-ui/core";

const EmptyIcon = () => (
  <SvgIcon viewBox="0 0 24 24">
    <path fill="transparent" d="M0 0h24v24H0z" />
  </SvgIcon>
);

export default EmptyIcon;
